module.exports = {
  app_url: process.env.REACT_APP_APP_URL ?? "",
  product: "Admin Portal",
  api_url: process.env.REACT_APP_API_URL
    ? process.env.REACT_APP_API_URL
    : "http://localhost",
  api_version: 6,
  customer: process.env.REACT_APP_CUSTOMER,
  logrocket: process.env.REACT_APP_LOGROCKET,
  privacy_policy_url: "https://cosoft.co.uk/connect-privacy-policy/",
};
